export default function Council2025Entries() {
    return (
        <table id="filetable">
        {/*Start Table*/}
        <tr>
          <th id="a-m">Meeting Date</th>
          <th>Minutes</th>
          <th>Agenda</th>
        </tr>
         {/*Start File*/}
        <tr>
          <td>12-16-2025</td>
          <td><a href="../docs/council/minutes/2025/2025-12-16-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a></td>
          <td>
            <a href="../docs/council/minutes/2025/2025-12-16-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
        </tr>
        {/*End File*/}
          {/*Start File*/}
        <tr>
          <td>11-18-2025</td>
           <td><a href="../docs/council/minutes/2025/2025-11-18-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a></td>
          <td>
            <a href="../docs/council/minutes/2025/2025-11-18-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
        </tr>
        {/*End File*/}
         {/*Start File*/}
        <tr>
          <td>10-21-2025</td>
           <td><a href="../docs/council/minutes/2025/2025-10-21-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a></td>
          <td>
            <a href="../docs/council/minutes/2025/2025-10-21-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>10-02-2025</td>
           <td><a href="../docs/council/minutes/2025/2025-10-02-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a></td>
          <td>
            <a href="../docs/council/minutes/2025/2025-10-02-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
        </tr>
        {/*End File*/}
         {/*Start File*/}
        <tr>
          <td>09-16-2025</td>
           <td><a href="../docs/council/minutes/2025/2025-09-16-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a></td>
          <td>
            <a href="../docs/council/minutes/2025/2025-09-16-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
        </tr>
        {/*End File*/}
         {/*Start File*/}
        <tr>
          <td>08-19-2025</td>
           <td><a href="../docs/council/minutes/2025/2025-08-19-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a></td>
          <td>
            <a href="../docs/council/minutes/2025/2025-08-19-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
        </tr>
        {/*End File*/}
         {/*Start File*/}
        <tr>
          <td>07-15-2025</td>
          <td><a href="../docs/council/minutes/2025/2025-07-15-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a></td>
          <td>
            <a href="../docs/council/minutes/2025/2025-07-15-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>06-17-2025</td>
              <td><a href="../docs/council/minutes/2025/2025-06-17-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a></td>
          <td>
            <a href="../docs/council/minutes/2025/2025-06-17-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
        </tr>
        {/*End File*/}
         {/*Start File*/}
        <tr>
          <td>05-21-2025</td>
              <td><a href="../docs/council/minutes/2025/2025-05-21-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a></td>
          <td>
            <a href="../docs/council/minutes/2025/2025-05-21-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>04-15-2025</td>
          <td><a href="../docs/council/minutes/2025/2025-04-15-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a></td>
          <td>
            <a href="../docs/council/minutes/2025/2025-04-15-BCAgendaR1.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>03-18-2025</td>
          <td>
            <a href="../docs/council/minutes/2025/2025-03-18-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>
            <a href="../docs/council/minutes/2025/2025-03-18-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>02-18-2025</td>
          <td>
            <a href="../docs/council/minutes/2025/2025-02-18-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>
            <a href="../docs/council/minutes/2025/2025-02-18-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>01-21-2025</td>
          <td>
            <a href="../docs/council/minutes/2025/2025-01-21-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
          <td>
            <a href="../docs/council/minutes/2025/2025-01-21-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; Available
            </a>
          </td>
        </tr>
        {/*End File*/}
      </table>
        )
        }
        